var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon66(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141 93",
    style: {
      enableBackground: "new 0 0 141 93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6,1.6L123.6,1.6l-0.1-0.1c-2-0.9-4.2-1.5-6.5-1.5H24c-2.1,0-4.1,0.4-6,1.2L17.9,1l-0.5,0.5 c-5.2,2.5-8.9,7.8-8.9,14v62C8.5,86,15.5,93,24,93h93c8.5,0,15.5-7,15.5-15.5v-62C132.5,9.3,128.9,4.1,123.6,1.6L123.6,1.6z  M114.5,10.3L74.9,48.9c-2.1,2.1-5.7,2.1-7.9,0L27.4,10.3H114.5z M117,82.7H24c-2.9,0-5.2-2.3-5.2-5.2V16.4l40.9,39.9 c3.1,3,7.1,4.5,11.2,4.5c4,0,8.1-1.5,11.2-4.5l40.1-39.1v60.2C122.2,80.3,119.9,82.7,117,82.7L117,82.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon66);
export default __webpack_public_path__ + "static/media/icon66.b4b8ec5c77058429048296865cdf4036.svg";
export { ForwardRef as ReactComponent };